import { OFM_LOCALE, OMF_TIME_ZONE } from "@/pages/tax/extracao-nf-ofm/constants/const";

export const formatDateTime = (dateTime: string): string => {
    try {
        return new Date(dateTime).toLocaleString('pt-BR')
    } catch {
        return dateTime
    }
}

type Dateish = string | number | Date | null | undefined;

function toDate(value: Dateish): Date | null {
  if (value == null) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Formata só a data (dd/mm/aaaa) com timezone configurável padrao "America/Sao_Paulo". */
export function formatDate(
  value: Dateish,
  opts?: { locale?: string; timeZone?: string; fallback?: string }
): string {
  const { locale = OFM_LOCALE, timeZone = OMF_TIME_ZONE, fallback = "-" } = opts || {};
  const d = toDate(value);
  if (!d) return fallback;
  return d.toLocaleDateString(locale, { timeZone });
}

/** Formata data e hora (dd/mm/aaaa hh:mm) com timezone configurável padrão "America/Sao_Paulo". */
export function formatDateTime2(
  value: Dateish,
  opts?: {
    locale?: string;
    timeZone?: string;
    includeSeconds?: boolean;
    fallback?: string;
  }
): string {
  const {
    locale = OFM_LOCALE,
    timeZone = OMF_TIME_ZONE,
    includeSeconds = false,
    fallback = "-",
  } = opts || {};
  const d = toDate(value);
  if (!d) return fallback;
  return d.toLocaleString(locale, {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    ...(includeSeconds ? { second: "2-digit" } : {}),
  });
}

/**
 * Formata data e hora convertendo o timezone (padrão "America/Sao_Paulo"),
 * com layout limpo "dd/mm/aaaa hh:mm" (sem vírgula).
 */
export function formatAndConvertTimezoneDateTime(
  value: Dateish,
  opts?: { locale?: string; timeZone?: string; fallback?: string }
): string {
  const { locale = OFM_LOCALE, timeZone = OMF_TIME_ZONE, fallback = "-" } = opts || {};
  const d = toDate(value);
  if (!d) return fallback;
  const date = d.toLocaleDateString(locale, { timeZone });
  const time = d.toLocaleTimeString(locale, {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${date} ${time}`;
}

/** Formata um período (início → fim). Se algum lado faltar, mostra o que tiver. */
export function formatDateRange(
  start: Dateish,
  end: Dateish,
  opts?: { locale?: string; timeZone?: string; separator?: string; fallback?: string }
): string {
  const { locale = OFM_LOCALE, timeZone = OMF_TIME_ZONE, separator = " → ", fallback = "-" } = opts || {};
  const s = toDate(start);
  const e = toDate(end);
  if (!s && !e) return fallback;
  if (s && e) return `${formatDate(s, { locale, timeZone })}${separator}${formatDate(e, { locale, timeZone })}`;
  return s ? formatDate(s, { locale, timeZone, fallback }) : formatDate(e!, { locale, timeZone, fallback });
}
